<template>
  <!-- 骨架屏 -->
  <div v-if="pageLoading" style="padding-top: 80px">
    <van-skeleton title :row="5" />
    <van-skeleton title :row="5" style="margin-top: 30px" />
  </div>
  <div
    v-else-if="isEmptyRecord"
    class="collectRecord-page collectRecord-page--empty"
  >
    <div class="empty-state">
      <img
        class="empty-state__img"
        src="@/assets/imgs/xibReturnGift/jimeng_grey.png"
        alt=""
      />
      <div class="empty-state__text">无领取记录</div>
    </div>
  </div>
  <div v-else class="collectRecord-page">
    <div class="address-box">
      <div class="address-row1">
        {{ data?.provinceName }}{{ data?.cityName }}{{ data?.countyName
        }}{{ data?.streetName }}
      </div>
      <div class="address-row2">{{ data?.detailAddress }}</div>
      <div class="address-row3">
        <span class="address-row3-name">{{ data?.receiverName }}</span>
        <span class="address-row3-phone">{{ data?.receiverPhone }}</span>
      </div>
    </div>
    <div class="gift-box">
      <div class="gift-box-img">
        <img :src="data?.rightsImg" alt="" />
      </div>
      <div class="gift-box-name">{{ data?.rightsName }}</div>
    </div>
    <div class="order-detail-box">
      <div class="order-detail-title">订单明细</div>
      <div class="order-detail-row">
        <div class="label">订单编号</div>
        <div class="value-box">
          <span>{{ data?.orderNo }}</span>
          <span class="copy-btn" @click="copy(data?.orderNo)">复制</span>
        </div>
      </div>
      <div class="order-detail-row">
        <div class="label">领取时间</div>
        <div class="value-box">
          <span>{{ data?.receiveTime }}</span>
        </div>
      </div>
      <div class="order-detail-row">
        <div class="label">发货状态</div>
        <div class="value-box">
          <span style="font-weight: bold; color: #131821">{{
            data?.orderStatusDesc
          }}</span>
        </div>
      </div>
      <div v-if="data?.orderStatus === 1" class="order-detail-row">
        <div class="label">发货时间</div>
        <div class="value-box">
          <span>{{ data?.deliveryTime }}</span>
        </div>
      </div>
      <div v-if="data?.orderStatus === 1" class="order-detail-row">
        <div class="label">物流单号</div>
        <div class="value-box">
          <span>{{ data?.logisticsNo }}</span>
          <span class="copy-btn" @click="copy(data?.logisticsNo)">复制</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { queryRecord } from "@/api/xibReturnGift.js";
import useClipboard from "vue-clipboard3";
const { toClipboard } = useClipboard();

export default {
  name: "xibReturnGift-collectRecord",
  data() {
    return {
      pageLoading: true,
      isEmptyRecord: false,
      data: {},
    };
  },
  async mounted() {
    this.loadData();
  },
  methods: {
    async copy(text) {
      try {
        await toClipboard(text);
        this.$toast.success("复制成功!");
      } catch (e) {
        console.error(e);
        this.$toast.fail("复制失败!");
      }
    },
    async loadData() {
      try {
        const { code, data, message } = await queryRecord({});
        if (code === 0 && data == null && message === "暂无领取记录") {
          this.isEmptyRecord = true;
          this.data = null;
        } else if (code === 0) {
          this.isEmptyRecord = false;
          this.data = data || {};
        }
      } catch (e) {
        console.error(e);
        this.isEmptyRecord = false;
        this.data = {};
      } finally {
        this.pageLoading = false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.collectRecord-page {
  min-height: 100vh;
  background: linear-gradient(0deg, #d7d5ff, #ededed);
  padding: 10px 15px;
  color: #131821;
  box-sizing: border-box;

  &--empty {
    padding-top: 40px;
    box-sizing: border-box;
  }

  .empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;

    &__img {
      width: 77px;
      height: auto;
      display: block;
    }

    &__text {
      margin-top: 10px;
      font-size: 15px;
      font-weight: 500;
      color: #727272;
    }
  }

  .address-box {
    border-radius: 5px;
    padding: 15px;
    background: #fff;

    .address-row1 {
      font-size: 12px;
    }

    .address-row2 {
      font-weight: 500;
      font-size: 16px;
      margin-top: 10px;
      margin-bottom: 10px;
      line-height: 1.3;
      word-break: break-all;
    }

    .address-row3 {
      display: flex;
      gap: 5px;
    }
  }

  .gift-box {
    padding: 15px;
    background: #fff;
    display: flex;
    gap: 10px;
    margin-top: 12px;
    border-radius: 5px;

    .gift-box-img {
      width: 84px;
      height: 84px;
      border-radius: 5px;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #f2f2f2;
      padding: 5px;
      box-sizing: border-box;

      img {
        height: 100%;
      }
    }

    .gift-box-name {
      padding-top: 5px;
      font-size: 13px;
    }
  }

  .order-detail-box {
    padding: 15px;
    padding-bottom: 10px;
    background: #fff;
    margin-top: 12px;
    border-radius: 5px;

    .order-detail-title {
      font-weight: 500;
      font-size: 14px;
      margin-bottom: 15px;
      padding-top: 5px;
    }

    .order-detail-row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;
      font-size: 12px;
      color: #666666;
      height: 22px;
      align-items: center;

      .label {
        font-size: 12px;
        color: #666666;
      }

      .value-box {
        display: flex;
        align-items: center;
        gap: 5px;

        .copy-btn {
          width: 30px;
          height: 16px;
          background: #f2f2f2;
          border-radius: 7px;
          font-size: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }
  }
}
</style>
